import Amplify from 'aws-amplify'
import React from 'react'
import {render} from 'react-dom'
import awsconfig from './aws-exports'
import Signup from './components/Signup'

Amplify.configure(awsconfig)

// window.__SOLSELL_SIGNUP_CONFIG__ = {
//   redirectTo: '/verify'
// }

// const {redirectTo} = window.__SOLSELL_SIGNUP_CONFIG__

render(
  <Signup/>,
  document.getElementById('root')
)
